/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/conquest': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#1D1D1B"><path pid="0" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2z"/><path pid="1" d="M16 4C9.371 4 4 9.371 4 16s5.371 12 12 12 12-5.371 12-12S22.629 4 16 4zm5 5h-4.5v8H20v-7h1v8h-4.5v8h-1v-8H11v-8h1v7h3.5V9H11V8h10v1z"/></g>'
  }
})
